export default function getRoot(): string {
    return process.env.API_ROOT || '/';
}
